import { useState, useRef } from 'react';
import { uploadImage } from '../../utils/api';
import { FiUpload, FiLink, FiX, FiImage } from 'react-icons/fi';
import styles from './ImageUploader.module.css';

export default function ImageUploader({ value, onChange, label = 'Product Image' }) {
  const [tab, setTab]       = useState('url'); // 'url' | 'file'
  const [urlInput, setUrl]  = useState(value || '');
  const [uploading, setUploading] = useState(false);
  const [preview, setPreview]     = useState(value || '');
  const fileRef = useRef();

  const handleUrlApply = () => {
    setPreview(urlInput);
    onChange(urlInput);
  };

  const handleFile = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (file.size > 4 * 1024 * 1024) { alert('Max file size is 4MB'); return; }

    setUploading(true);
    try {
      const reader = new FileReader();
      reader.onload = async (ev) => {
        const base64 = ev.target.result;
        setPreview(base64);
        onChange(base64);

        // Optionally upload to server
        try {
          const { data } = await uploadImage({ image: base64 });
          if (data.url) { setPreview(data.url); onChange(data.url); }
        } catch {}
        setUploading(false);
      };
      reader.readAsDataURL(file);
    } catch { setUploading(false); }
  };

  const clear = () => { setPreview(''); setUrl(''); onChange(''); };

  return (
    <div className={styles.wrap}>
      <label className={styles.label}>{label}</label>

      {/* Preview */}
      {preview ? (
        <div className={styles.preview}>
          <img src={preview} alt="Preview" />
          <button type="button" className={styles.clearBtn} onClick={clear} title="Remove image">
            <FiX size={14} />
          </button>
        </div>
      ) : (
        <div className={styles.placeholder}>
          <FiImage size={32} />
          <p>No image</p>
        </div>
      )}

      {/* Tabs */}
      <div className={styles.tabs}>
        <button type="button" className={`${styles.tab} ${tab === 'url' ? styles.tabActive : ''}`} onClick={() => setTab('url')}>
          <FiLink size={13} /> Paste URL
        </button>
        <button type="button" className={`${styles.tab} ${tab === 'file' ? styles.tabActive : ''}`} onClick={() => setTab('file')}>
          <FiUpload size={13} /> Upload File
        </button>
      </div>

      {tab === 'url' && (
        <div className={styles.urlRow}>
          <input
            type="url" className="form-input" placeholder="https://example.com/image.jpg"
            value={urlInput} onChange={e => setUrl(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && handleUrlApply()}
          />
          <button type="button" className="btn btn-primary btn-sm" onClick={handleUrlApply}>Apply</button>
        </div>
      )}

      {tab === 'file' && (
        <div className={styles.fileArea} onClick={() => fileRef.current?.click()}>
          <input ref={fileRef} type="file" accept="image/*" style={{ display: 'none' }} onChange={handleFile} />
          {uploading ? (
            <><div className="spinner spinner-sm" /> Uploading…</>
          ) : (
            <><FiUpload size={18} /> Click to upload (JPG, PNG, WebP — max 4MB)</>
          )}
        </div>
      )}
    </div>
  );
}
